import React from 'react';

const MentionsLegalesPage = () => {
  return (
    <div className="legal-page container">
      <h1>Mentions légales</h1>

      <h2>1 - Édition du site</h2>
      <p>
        En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie
        numérique, il est précisé aux utilisateurs du site internet <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a>
        {' '}l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi:
      </p>
      <p>
        <strong>Propriétaire du site :</strong> SENANE YASSINE - Contact : <a href="mailto:senane.yassine44@gmail.com">senane.yassine44@gmail.com</a> 07 66 05 98 63 - Adresse : 4 RUE RENE DUMONT<br />
        44220 COUERON.
      </p>
      <p>
        <strong>Identification de l'entreprise :</strong> Entrepreneur individuel SENANE YASSINE au capital social de € - SIREN : 911203990 - RCS ou RM : - Adresse postale : 4 RUE RENE DUMONT
        <br />
        44220 COUERON.
      </p>
      <p>
        <strong>Directeur de la publication :</strong> YASSINE SENANE - Contact : <a href="mailto:senane.yassine44@gmail.com">senane.yassine44@gmail.com</a>.
      </p>
      <p>
        <strong>Hébergeur :</strong> OVH SAS - 2 rue Kellermann - BP 80157 - 59053 Roubaix Cedex 1 - Téléphone : 1007
      </p>
      <p>
        <strong>Délégué à la protection des données :</strong> SENANE YASSINE
      </p>
      <p>
        <strong>Autres contributeurs :</strong>
      </p>

      <h2>2 - Propriété intellectuelle et contrefaçons.</h2>
      <p>
        SENANE YASSINE est propriétaire des droits de propriété intellectuelle et détient les droits d’usage sur tous les éléments accessibles sur le site internet, notamment les textes,
        images, graphismes, logos, vidéos, architecture, icônes et sons.
      </p>
      <p>
        Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite,
        sauf autorisation écrite préalable de SENANE YASSINE.
      </p>
      <p>
        Toute exploitation non autorisée du site ou de l’un quelconque des éléments qu’il contient sera considérée comme constitutive d’une contrefaçon et poursuivie conformément
        aux dispositions des articles L.335-2 et suivants du Code de Propriété Intellectuelle.
      </p>

      <h2>3 - Limitations de responsabilité.</h2>
      <p>
        SENANE YASSINE ne pourra être tenu pour responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site
        <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer"> https://vie-et-couleurs.nokram.fr</a>.
      </p>
      <p>
        SENANE YASSINE décline toute responsabilité quant à l’utilisation qui pourrait être faite des informations et contenus présents sur
        <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer"> https://vie-et-couleurs.nokram.fr</a>.
      </p>
      <p>
        SENANE YASSINE s’engage à sécuriser au mieux le site <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a>,
        cependant sa responsabilité ne pourra être mise en cause si des données indésirables sont importées et installées sur son site à son insu.
      </p>
      <p>
        Des espaces interactifs (espace contact ou commentaires) sont à la disposition des utilisateurs. SENANE YASSINE se réserve le droit de supprimer, sans mise en demeure préalable,
        tout contenu déposé dans cet espace qui contreviendrait à la législation applicable en France, en particulier aux dispositions relatives à la protection des données.
      </p>
      <p>
        Le cas échéant, SENANE YASSINE se réserve également la possibilité de mettre en cause la responsabilité civile et/ou pénale de l’utilisateur, notamment en cas de message à
        caractère raciste, injurieux, diffamant, ou pornographique, quel que soit le support utilisé (texte, photographie …).
      </p>

      <h2>4 - CNIL et gestion des données personnelles.</h2>
      <p>
        Conformément aux dispositions de la loi 78-17 du 6 janvier 1978 modifiée, l’utilisateur du site <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a>
        dispose d’un droit d’accès, de modification et de suppression des informations collectées. Pour exercer ce droit, envoyez un message à notre Délégué à la Protection des Données : - .
      </p>
      <p>
        Pour plus d'informations sur la façon dont nous traitons vos données (type de données, finalité, destinataire...), lisez notre
        {' '}<a href="/politique-de-confidentialite">politique de confidentialité</a>.
      </p>

      <h2>5 - Liens hypertextes et cookies</h2>
      <p>
        Le site <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a> contient des liens hypertextes vers d’autres sites et dégage toute responsabilité à propos de ces liens externes
        ou des liens créés par d’autres sites vers <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a>.
      </p>
      <p>
        La navigation sur le site <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a> est susceptible de provoquer l’installation de cookie(s) sur l’ordinateur de l’utilisateur.
      </p>
      <p>
        Un "cookie" est un fichier de petite taille qui enregistre des informations relatives à la navigation d’un utilisateur sur un site. Les données ainsi obtenues permettent d'obtenir des mesures de fréquentation, par exemple.
      </p>
      <p>
        Vous avez la possibilité d’accepter ou de refuser les cookies en modifiant les paramètres de votre navigateur. Aucun cookie ne sera déposé sans votre consentement.
      </p>
      <p>
        Les cookies sont enregistrés pour une durée maximale de mois.
      </p>
      <p>
        Pour plus d'informations sur la façon dont nous faisons usage des cookies, lisez notre
        {' '}<a href="/politique-de-confidentialite">politique de confidentialité</a>.
      </p>

      <h2>6 - Droit applicable et attribution de juridiction.</h2>
      <p>
        Tout litige en relation avec l’utilisation du site <a href="https://vie-et-couleurs.nokram.fr" target="_blank" rel="noreferrer">https://vie-et-couleurs.nokram.fr</a> est soumis au droit français. En dehors des cas où la loi ne le permet pas,
        il est fait attribution exclusive de juridiction aux tribunaux compétents de .
      </p>
    </div>
  );
};

export default MentionsLegalesPage;



